import BookDemo from "./BookDemo";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "./Login";
import SchoolRoster from "./SchoolRoster";
import Dashboard from "./Dashboard";
import PricingPage from "./PricingPage";
import Checkout from "./Checkout";
import AdminInbox from "./AdminInbox";
import GatewayDemoSwitcher from "./demo/GatewayDemoSwitcher";
import { ssoToken } from "./api";

// Unknown paths go to the sign-in page (/login), keeping the query string: products send people to
// /login?redirect=<their own /sso/callback>, and dropping it would land them on the dashboard.
function ToSignIn() {
  const { search } = useLocation();
  return <Navigate to={`/login${search}`} replace />;
}

// Old links pointed at /login/dashboard; the dashboard is at /dashboard.
function LegacyDashboard() {
  const { search } = useLocation();
  return <Navigate to={`/dashboard${search}`} replace />;
}

// The demo account's view switcher. The dashboard keeps no token of its own (the gateway session cookie is the login), so
// ask for one whenever the page changes; it renders nothing unless this is a demo account.
function DemoSwitch() {
  const { pathname, search } = useLocation();
  const [tok, setTok] = useState(null);
  useEffect(() => { ssoToken().then(setTok).catch(() => setTok(null)); }, [pathname, search]);
  return <GatewayDemoSwitcher gatewayUrl={process.env.REACT_APP_GATEWAY_URL || window.location.origin} getToken={() => tok} homes={{ default: "/dashboard" }} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-center" />
      <DemoSwitch />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/dashboard" element={<LegacyDashboard />} />
        <Route path="/school-setup" element={<SchoolRoster />} />
        <Route path="/school-roster" element={<SchoolRoster />} />
        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/admin" element={<AdminInbox />} />
        <Route path="*" element={<ToSignIn />} />
      </Routes>
    </BrowserRouter>
  );
}
